module.exports = __webpack_public_path__ + "img/logo-white.55f1015d.png";